/**
 * Formate l'affichage d'une année d'études
 * @param annee - L'année sous forme de string ("1", "2", "3" ou "Année académique : X")
 * @returns L'affichage formaté
 */
export function formatAnnee(annee: string | null | undefined): string {
  if (!annee) {
    return 'Pas encore renseigné';
  }
  
  // Si déjà formaté, retourner tel quel
  if (annee.includes('Année académique')) {
    return annee;
  }
  
  // Sinon, formater avec "Année académique : X"
  return `Année académique : ${annee}`;
}
